<template>
    <div class="table-filter pt-4 pb-4" v-if="pageTypes">
        <div class="category-area tab-selector mt-4" v-if="pageTypes.length > 1">
            <span v-for="pageType in pageTypes"
                  class="category"
                  :class="{'selected' : selectedPageType && selectedPageType.type === pageType.type}"
                  @click="selectPageType(pageType)"
            >
                {{pageType.label}}
            </span>
        </div>
        <div class="row pt-5 pb-4" v-if="selectedPageType">
            <span class="col-12 text-center" v-if="pages.length < 1 && !isLoading" v-html="noResults"></span>
            <div class="col-md-4 mb-4"
                v-for="(page, index) in pages"
                v-if="pages.length > 0"
            >
                <a :href="page.href" class="card" :id="'page-' + page.id">
                    <div class="card-img-top"
                         v-lazy:background-image="page.image_url"
                    ></div>
                    <div class="spinner-border" role="status">
                      <span class="visually-hidden"></span>
                    </div>
                    <div class="card-body">
                        <h5 class="card-title">{{page.title}}</h5>
                        <div class="card-text">{{page.lead}}</div>
                    </div>
                </a>
            </div>
        </div>

        <div v-if="isLoading" class="text-center pt-5 pb-4 py-3">
          <loading-feedback :active="isLoading"></loading-feedback>
        </div>

        <div class="row pt-5 pb-4" v-if="!isLoading && showLoadMore" >
          <a @click="getNewPage" class="btn btn-primary d-inline-block m-auto">{{$lang.get('pagination.loadmore')}}</a>
        </div>

        <!--<b-nav pills v-b-scrollspy class="flex-column pt-4 pb-4 scroll-spy-debug d-none" v-if="pages.length > 1">
          <b-nav-item :href="'#page-' + page.id" v-for="(page, index) in pages">{{ page.id }}</b-nav-item>
        </b-nav>-->

        <!--<div class="pagination-pages pt-4 pb-4" v-if="pages.length > 1" style="display: none">
            <span v-if="currentPage>1" class="previousPage" @click="goToPrev"> < </span>
            <span v-text="page < totalPages-1 && page+1 !== currentPage ? (page+1)+',' : page+1" @click="goToPage(page+1)" v-for="page in paginationPages[0]" class="selectPage" :class="{'selected' : currentPage === page+1}"></span>
            <span v-if="paginationPages[1] !== undefined && currentPage > 5">...</span>
            <span v-text="page < totalPages-1 && page+1 !== currentPage ? (page+1)+',' : page+1" @click="goToPage(page+1)" v-if="paginationPages[1] !== undefined" v-for="page in paginationPages[1]" class="selectPage" :class="{'selected' : currentPage === page+1}"></span>
            <span v-if="paginationPages[1] !== undefined && currentPage < totalPages-4">...</span>
            <span v-text="page < totalPages-1 && page+1 !== currentPage ? (page+1)+',' : page+1" @click="goToPage(page+1)" v-if="paginationPages[2] !== undefined" v-for="page in paginationPages[2]" class="selectPage" :class="{'selected' : currentPage === page+1}"></span>
            <span v-if="currentPage<totalPages" class="nextPage" @click="goToNext"> > </span>
        </div>-->
    </div>
</template>

<script>
    import Content from "../services/Content";
    import {DateTime} from "luxon";

    export default {
        props: [
            'pageTypes',
            'taxonomy',
            'max',
            'locale',
            'noResults',
            'profileSlug',
            'query',
            'letter',
            'filterTaxonomy',
            'excludeWithTags'
        ],

        data: () => {
            return {
                pages: [],
                selectedPageType: null,
                currentPage: 1,
                totalPages: 1,
                searchFilter: '',
                isLoading: false,
                showLoadMore: false,
                taxonomyTags: []
            }
        },

        computed:{
            paginationPages:function(){
                let chunks = [];
                chunks[0] = [];
                chunks[1] = [];
                chunks[2] = [];
                chunks[0].push(0,1,2);
                if(this.totalPages <= 3){
                    chunks[1] = undefined;
                    chunks[2] = undefined;
                    chunks[0] = [];
                    for(let i = 0; i <= this.totalPages; i++)
                        if(i<this.totalPages)
                            chunks[0].push(i)
                }else if(this.totalPages <=5){
                    chunks[1] = undefined;
                    for(let i = 3; i<= this.totalPages-1; i++)
                        chunks[2].push(i);
                }else{
                    chunks[2].push(this.totalPages-3, this.totalPages-2, this.totalPages-1);
                    if(this.currentPage-1 > 2 && this.currentPage-1 < this.totalPages-3)
                        for(let i = this.currentPage -2; i<= this.currentPage; i++)
                            if(i > 2 && i < this.totalPages-3)
                                chunks[1].push(i)
                }
                return chunks;
            }
        },

        beforeMount() {
            this.taxonomyTags = this.taxonomy;
        },

        mounted: function () {
            this.selectPageType(this.pageTypes[0]);
        },

        methods: {
            selectPageType: function (pageType) {
                this.selectedPageType = pageType;
                this.currentPage = 1;
                this.searchFilter = '';

                this.fetchPages();
            },

            fetchPages: function (add = false) {
                this.isLoading = true;
                this.taxonomyTags = this.filterTaxonomy ? this.filterTaxonomy : this.taxonomyTags;

                let excludedTags = this.excludeWithTags !== undefined ? this.excludeWithTags : [];
                let pageWithTagsToExclude = this.taxonomyTags.length > 0 ? [] : excludedTags;

                Content.FetchAllWithTypeAndTaxonomy(
                        this.selectedPageType.type,
                        this.currentPage,
                        JSON.stringify(this.taxonomyTags),
                        this.max,
                        this.locale,
                        this.profileSlug,
                        this.query,
                        this.letter,
                        JSON.stringify(pageWithTagsToExclude)
                ).then((res) => {
                        this.isLoading = false;
                        this.showLoadMore = res.meta.pagination.total_pages == this.currentPage ? false : true;
                        if (add) {
                          this.pages = this.pages.concat(res.data);
                          console.log(this.pages);
                          this.totalPages += res.meta.pagination.total_pages
                        } else {
                          this.pages = res.data;
                          this.totalPages = res.meta.pagination.total_pages
                        }
                        this.$forceUpdate();
                    })
                    .catch((err) => {
                        this.isLoading = false;
                    })
            },

            goToPrev: function () {
                if (--this.currentPage < 1) {
                    this.currentPage = 1;
                }

                this.fetchPages();
            },

            goToNext: function () {
                if (++this.currentPage > this.totalPages) {
                    this.currentPage = this.totalPages;
                }

                this.fetchPages();
            },

            goToPage: function(page){
                this.currentPage = page;
                this.fetchPages();
            },

            renderDate: (date) => {
                if (!date) {
                    return '';
                }

                return DateTime
                    .fromFormat(date, 'yyyy-MM-dd HH:mm:ss')
                    .toFormat('dd/MM/yyyy')
            },

            /*onActivateScrollSpy(target) {
              let pageId = parseInt(target.replace('#page-', ''));

              //Check if is view in the last 4 pages
              if (
                  pageId === this.pages[this.pages.length - 1].id ||
                  pageId === this.pages[this.pages.length - 2].id ||
                  pageId === this.pages[this.pages.length - 3].id ||
                  pageId === this.pages[this.pages.length - 4].id
              ) {
                this.getNewPage();
              }
            },*/

            getNewPage: function () {
              this.currentPage += 1;
              this.fetchPages(true);
            },
        },
    }
</script>
